import { LoadingAnimation } from '@instamenu/ui-icons';
import { CenteredBox } from '../box/box';
import { AnimatedLogo } from './animated-logo';
import { palette } from '@instamenu/ui-vanilla-extract';

export const Loading = ({
  logo = false,
  containerStyle,
}: {
  logo?: boolean;
  containerStyle?: React.CSSProperties;
}) => {
  return (
    <CenteredBox style={containerStyle}>
      {logo ? (
        <AnimatedLogo />
      ) : (
        <LoadingAnimation width={48} height={48} color={palette.primary} />
      )}
    </CenteredBox>
  );
};
